import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
  FooterLeft,
  FooterRowContainer,
  LinkWrapper,
} from "./styles";
import { Link } from "react-router-dom";

interface SocialLinkProps {
  href: string;
  src: string;
  name?: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src, name = "" }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        {name}
        {/* <SvgIcon src={src} width="25px" height="25px" /> */}
      </a>
    );
  };

  return (
    <>
      <Extra>
        <Container border={true}>
          <FooterRowContainer>
            <FooterLeft>
              <NavLink to="/">
                <LogoContainer>
                  <SvgIcon
                    src="logo.jpeg"
                    aria-label="homepage"
                    width="101px"
                    height="64px"
                  />
                </LogoContainer>
              </NavLink>
            </FooterLeft>

            <FooterContainer>
              <LinkWrapper>
                <Link to="/about-us">About us</Link>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                {/* <Link to="/contact-us">Contact Us</Link> */}
                <a href="https://play.google.com/store/apps/details?id=com.render.evcare">
                  Download App
                </a>
              </LinkWrapper>

              <p>
                &copy; {new Date().getFullYear()} EV Care India. All rights
                reserved.
              </p>
            </FooterContainer>
          </FooterRowContainer>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
